import React from "react";
import styled from "styled-components";
//
import Iframe from "react-iframe";
//
export default ({ link, title, ...rest }) => (
  <Wrap>
    <Top>
      <Title>{title}</Title>
    </Top>
    <Calendar>
      <Iframe
        url={link.url}
        width="100%"
        height="100%"
        frameBorder="0"
        wkst="2"
        // scrolling="no"
      />
    </Calendar>
  </Wrap>
);
//
const Wrap = styled.div`
  margin: 0 auto;
  max-width: 1350px;
  min-height: 100vh;
  min-height: calc(100vh - 136px);
  position: relative;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

const Top = styled.div`
  background-color: #ffff;
  border-bottom: 1px solid #d9dce4;
  position: -webkit-sticky;
  position: sticky;
  top: 0;

  @media (min-width: 769px) {
    margin: 0 1rem;
  }
`;

const Title = styled.h2`
  min-height: 3rem;
  min-height: calc(3rem + 2px);
  margin: 0 auto;
  text-align: center;
  line-height: 3rem;
  line-height: calc(3rem + 2px);
  white-space: nowrap;

  @media (min-width: 769px) {
    padding: 0 0.8rem;
    text-align: left;
  }
`;

const Calendar = styled.div`
  margin: 0 1rem;
  padding: 1.5rem 0;
  height: 100vh;
  height: calc(100vh - 5rem);
`;
